module.exports = __webpack_public_path__ + "static/media/Sec-3_Background_Mobile.c189964e.png";